export default "__VITE_ASSET__XX8JJQAJ__"